import { useRef, useState } from "react";
import { Play, Star } from "lucide-react";
import { API } from "../../lib/adventureApi";

const BASE = API.replace(/\/api$/, "");

export default function VideoReviewCard({ review, dark = false }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const play = () => { setPlaying(true); ref.current?.play().catch(() => {}); };

  return (
    <figure className="flex flex-col" data-testid={`video-review-${review.token}`}>
      <div className="relative aspect-[9/16] rounded-lg overflow-hidden bg-black ring-1 ring-black/10">
        <video ref={ref} src={`${BASE}${review.video_url}#t=0.5`} preload="metadata" playsInline controls={playing}
          onEnded={() => setPlaying(false)} className="absolute inset-0 w-full h-full object-cover" />
        {!playing && (
          <button onClick={play} data-testid={`video-review-play-${review.token}`} aria-label="Play review"
            className="group absolute inset-0 flex items-end bg-gradient-to-t from-black/75 via-black/5 to-transparent p-4 text-left">
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="w-14 h-14 rounded-full bg-terracotta/95 flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                <Play className="w-6 h-6 text-white ml-0.5" fill="currentColor" />
              </span>
            </span>
            <span className="relative">
              <span className="flex gap-0.5 mb-1">{[...Array(review.rating || 5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-terracotta text-terracotta" />)}</span>
              <span className="block font-display font-bold text-white text-lg leading-tight">{review.first_name}</span>
            </span>
          </button>
        )}
      </div>
      {review.trip_name && (
        <figcaption className={`mt-2 font-mono text-[10px] uppercase tracking-widest line-clamp-1 ${dark ? "text-white/50" : "text-ink-muted"}`}>{review.trip_name}</figcaption>
      )}
    </figure>
  );
}
